var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E5F6F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4131_26247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7971 29.208C36.7916 29.0026 36.7083 28.8028 36.5584 28.6529L31.2295 23.2796C31.0741 23.1242 30.8576 23.0354 30.6356 23.0354H21.7485C20.7827 23.0354 20 23.8181 20 24.7839V43.5738C20 44.5453 20.7882 45.3335 21.7596 45.3335H35.0486C36.0144 45.3335 36.7971 44.5508 36.7971 43.5849V29.5189C36.8027 29.4745 36.8138 29.4245 36.8138 29.3801C36.8138 29.3246 36.8082 29.2635 36.7971 29.2136V29.208ZM31.3239 25.7332L34.1105 28.5419H31.4072C31.3628 28.5419 31.3239 28.5031 31.3239 28.4587V25.7332ZM35.0541 43.6627H21.7596C21.7097 43.6627 21.6653 43.6238 21.6653 43.5683V24.7839C21.6653 24.7395 21.7041 24.7007 21.7485 24.7007H29.6531V28.4642C29.6531 29.4301 30.4357 30.2128 31.4016 30.2128H35.1318V43.5905C35.1318 43.6349 35.093 43.6738 35.0486 43.6738L35.0541 43.6627Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8616 31.9778H23.9357C23.4749 31.9778 23.103 32.3497 23.103 32.8104C23.103 33.2712 23.4749 33.6431 23.9357 33.6431H32.8616C33.3223 33.6431 33.6942 33.2712 33.6942 32.8104C33.6942 32.3497 33.3223 31.9778 32.8616 31.9778Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8616 35.6416H23.9357C23.4749 35.6416 23.103 36.0135 23.103 36.4742C23.103 36.935 23.4749 37.3069 23.9357 37.3069H32.8616C33.3223 37.3069 33.6942 36.935 33.6942 36.4742C33.6942 36.0135 33.3223 35.6416 32.8616 35.6416Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8616 39.2996H23.9357C23.4749 39.2996 23.103 39.6715 23.103 40.1322C23.103 40.5929 23.4749 40.9648 23.9357 40.9648H32.8616C33.3223 40.9648 33.6942 40.5929 33.6942 40.1322C33.6942 39.6715 33.3223 39.2996 32.8616 39.2996Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8976 25.0115C42.8976 24.9671 42.892 24.9226 42.8865 24.8782C42.8865 24.6562 42.7977 24.4453 42.6478 24.2898L37.3189 18.911C37.1635 18.7556 36.947 18.6667 36.7249 18.6667H27.8379C26.872 18.6667 26.0894 19.4494 26.0894 20.4153V21.4866C26.0894 21.9473 26.4613 22.3193 26.922 22.3193C27.3827 22.3193 27.7546 21.9473 27.7546 21.4866V20.4153C27.7546 20.3709 27.7935 20.332 27.8379 20.332H35.7424V24.0956C35.7424 25.0614 36.5251 25.8441 37.491 25.8441H41.2212V39.2218C41.2212 39.2662 41.1823 39.3051 41.1379 39.3051H38.1793C37.7186 39.3051 37.3466 39.677 37.3466 40.1377C37.3466 40.5985 37.7186 40.9704 38.1793 40.9704H41.1379C42.1038 40.9704 42.8865 40.1877 42.8865 39.2218V25.1447C42.892 25.1003 42.8976 25.0559 42.8976 25.0115ZM37.4077 24.0956V21.3701L40.1943 24.1788H37.491C37.4466 24.1788 37.4077 24.14 37.4077 24.0956Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4131_26247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8976,
    height: 26.6667,
    fill: "white",
    transform: "translate(20 18.6667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.c67370c0acc59a20dae92394772a8f0e.svg";
export { ForwardRef as ReactComponent };